<template>
  <div class="power-generation">
    <el-row class="box-top">
      <div class="left">
        <div class="left-content">
          <p v-for="(item,index) in upsData" :key="index" @click="changeColor(item,index)" :value="item.value" class="left-content-box" :class="{'spanColor':index==isActive }">{{item.value}}</p>
        </div>
      </div>
    </el-row>
    <el-row class="box">
      <el-col :span="24" class="box-right">
        <el-row class="main">
          <el-row class="right-content">
            <el-row class="right-content-top">
              <div class="right-content-top-title">{{ups}}</div>
              <div class="right-content-top-usp">最新数据时间:<span class="usp-small">{{nowTime}}</span></div>
            </el-row>
            <el-row class="imgBox">
              <el-row class="imgbottom">
                <el-col style="height:668px">
                  <div class="postTop">
                    <div class="postimgonennew"><img :src="bottomLine"><span class="line">F1线</span></div>
                    <div class="postcentent" @click="setMeasured">
                      <img :src="generator1" class="postimgtwo">
                      <div class="imgtitle postbottom">
                        <p style="text-align: center;">1#发电</p>
                        <div class="conten-box">
                          <div class="ziti">进线电流:</div>
                          <div class="value">{{indoorEle1Red}}A</div>
                          <div class="valueGreen">{{indoorEle1Green}}A</div>
                          <div class="valueYell">{{indoorEle1Yello}}A</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">出线电流:</div>
                          <div class="value">{{ontdoorEle1Red}}A</div>
                          <div class="valueGreen">{{ontdoorEle1Green}}A</div>
                          <div class="valueYell">{{ontdoorEle1Yello}}A</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">绕组温度:</div>
                          <div class="value">{{temperature1Red}}℃</div>
                          <div class="valueGreen">{{temperature1Green}}℃</div>
                          <div class="valueGreen">{{temperature1Yello}}℃</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">实在功率:</div>
                          <div class="valuewhile">{{truePower1}}KW</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">状态:</div>
                          <div class="valuewhile">{{state1}}</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">风机:</div>
                          <div class="valuewhile">
                            <el-switch v-model="value1" active-color="#0097EE" inactive-color="#ff4949">
                            </el-switch>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col style="height:668px">
                  <div class="postTop">
                    <div class="postcentent" @click="setMeasured">
                      <img :src="generator2" class="postimgtwo">
                      <div class="imgtitle postbottom">
                        <p style="text-align: center;">2#发电机</p>
                        <div class="conten-box">
                          <div class="ziti">进线电流:</div>
                          <div class="value">{{indoorEle2Red}}A</div>
                          <div class="valueGreen">{{indoorEle2Green}}A</div>
                          <div class="valueYell">{{indoorEle2Yello}}A</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">出线电流:</div>
                          <div class="value">{{ontdoorEle2Red}}A</div>
                          <div class="valueGreen">{{ontdoorEle2Green}}A</div>
                          <div class="valueYell">{{ontdoorEle2Yello}}A</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">绕组温度:</div>
                          <div class="value">{{temperature2Red}}℃</div>
                          <div class="valueGreen">{{temperature2Green}}℃</div>
                          <div class="valueGreen">{{temperature2Yello}}℃</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">实在功率:</div>
                          <div class="valuewhile">{{truePower2}}KW</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">状态:</div>
                          <div class="valuewhile">{{state2}}</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">风机:</div>
                          <div class="valuewhile">
                            <el-switch v-model="value2" active-color="#0097EE" inactive-color="#ff4949">
                            </el-switch>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col style="height:668px">
                  <div class="postTop">
                    <div class="postcentent" @click="setMeasured">
                      <img :src="generator2" class="postimgtwo">
                      <div class="imgtitle postbottom">
                        <p style="text-align: center;">3#发电机</p>
                        <div class="conten-box">
                          <div class="ziti">进线电流:</div>
                          <div class="value">{{indoorEle3Red}}A</div>
                          <div class="valueGreen">{{indoorEle3Green}}A</div>
                          <div class="valueYell">{{indoorEle3Yello}}A</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">出线电流:</div>
                          <div class="value">{{ontdoorEle3Red}}A</div>
                          <div class="valueGreen">{{ontdoorEle3Green}}A</div>
                          <div class="valueYell">{{ontdoorEle3Yello}}A</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">绕组温度:</div>
                          <div class="value">{{temperature3Red}}℃</div>
                          <div class="valueGreen">{{temperature3Green}}℃</div>
                          <div class="valueGreen">{{temperature3Yello}}℃</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">实在功率:</div>
                          <div class="valuewhile">{{truePower3}}KW</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">状态:</div>
                          <div class="valuewhile">{{state3}}</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">风机:</div>
                          <div class="valuewhile">
                            <el-switch v-model="value3" active-color="#0097EE" inactive-color="#ff4949">
                            </el-switch>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
                <el-col style="height:668px">
                  <div class="postTop">
                    <div class="postimgone"><img :src="bottomLine"><span class="line">F12线</span></div>
                    <div class="postcentent" @click="setMeasured">
                      <img :src="generator3" class="postimgtwo">
                      <div class="imgtitle postbottom">
                        <p style="text-align: center;">4#发电机</p>
                        <div class="conten-box">
                          <div class="ziti">进线电流:</div>
                          <div class="value">{{indoorEle4Red}}A</div>
                          <div class="valueGreen">{{indoorEle4Green}}A</div>
                          <div class="valueYell">{{indoorEle4Yello}}A</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">出线电流:</div>
                          <div class="value">{{ontdoorEle4Red}}A</div>
                          <div class="valueGreen">{{ontdoorEle4Green}}A</div>
                          <div class="valueYell">{{ontdoorEle4Yello}}A</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">绕组温度:</div>
                          <div class="value">{{temperature4Red}}℃</div>
                          <div class="valueGreen">{{temperature4Green}}℃</div>
                          <div class="valueGreen">{{temperature4Yello}}℃</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">实在功率:</div>
                          <div class="valuewhile">{{truePower4}}KW</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">状态:</div>
                          <div class="valuewhile">{{state4}}</div>
                        </div>
                        <div class="conten-box">
                          <div class="ziti">风机:</div>
                          <div class="valuewhile">
                            <el-switch v-model="value4" active-color="#0097EE" inactive-color="#ff4949">
                            </el-switch>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </el-col>
              </el-row>
            </el-row>
          </el-row>
        </el-row>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import api from '@common/api/index.js'
import dateTool from '@/utils/dateTool'
import generator1 from '@/assets/images/monitoring/generator1.png'
import generator2 from '@/assets/images/monitoring/generator2.png'
import generator3 from '@/assets/images/monitoring/generator3.png'
import bottomLine from '@/assets/images/monitoring/bottomLine.png'
export default {
  name: "powerGeneration",
  // 引用组件
  data () {
    return {
      upsData: [
        { id: 0, value: "1号电机房" },
        { id: 1, value: "2号电机房" },
        { id: 2, value: "3号电机房" },
      ],
      isActive: false,
      ups: '1号电机房',
      nowTime: "2010-10-09 10:00:00",
      //1#
      indoorEle1Red: '1',
      indoorEle1Green: '2',
      indoorEle1Yello: '3',
      ontdoorEle1Red: '4',
      ontdoorEle1Green: '5',
      ontdoorEle1Yello: '5',
      temperature1Red: "21",
      temperature1Green: "21",
      temperature1Yello: "21",
      truePower1: "21",
      state1: "投入",
      value1: true,
      //1#
      //2#
      indoorEle2Red: '1',
      indoorEle2Green: '2',
      indoorEle2Yello: '3',
      ontdoorEle2Red: '4',
      ontdoorEle2Green: '5',
      ontdoorEle2Yello: '5',
      temperature2Red: "21",
      temperature2Green: "21",
      temperature2Yello: "21",
      truePower2: "21",
      state2: "投入",
      value2: true,
      //2#
      //3#
      indoorEle3Red: '1',
      indoorEle3Green: '2',
      indoorEle3Yello: '3',
      ontdoorEle3Red: '4',
      ontdoorEle3Green: '5',
      ontdoorEle3Yello: '5',
      temperature3Red: "21",
      temperature3Green: "21",
      temperature3Yello: "21",
      truePower3: "21",
      state3: "投入",
      value3: true,
      //3#
      //4#
      indoorEle4Red: '1',
      indoorEle4Green: '2',
      indoorEle4Yello: '3',
      ontdoorEle4Red: '4',
      ontdoorEle4Green: '5',
      ontdoorEle4Yello: '5',
      temperature4Red: "21",
      temperature4Green: "21",
      temperature4Yello: "21",
      truePower4: "21",
      state4: "投入",
      value4: true,
      //4#
      generator1: generator1,
      generator2: generator2,
      generator3: generator3,
      bottomLine: bottomLine
    };
  },
  // 在实例初始化之后，数据观测(data observer) 和 event/watcher 事件配置之前被调用。
  beforeCreate () { },
  // 实例已经创建完成之后被调用。
  create () { },
  // el 被新创建的 vm.$el 替换，并挂载到实例上去之后调用该钩子。
  mounted () {
    this.nowTime = dateTool.format(new Date(), "yyyy-MM-dd hh:mm:ss")
  },
  // keep-alive组件激活时调用
  activated () { },
  // 数据更改导致的虚拟 DOM 重新渲染和打补丁，在这之后会调用该钩子
  updated () { },
  //当前路由改变
  beforeRouteUpdate () { },
  // Vue 实例销毁后调用
  destroyed () { },
  // 计算属性
  computed: {},
  // 数据监听
  watch: {},
  // 方法定义
  methods: {
    changeColor (item, index) {
      let vm = this
      vm.isActive = index
      vm.ups = item.value
    },
    setMeasured () {
      console.log("点击")
    }
  },
};
</script>
<style lang="scss" scoped>
.power-generation {
  // height: 100%;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  // background: rgba(2,14,27);
  .box-top {
    width: 100%;
    height: 10%;
    background: rgba(2, 14, 27);
    .left {
      width: 80%;
      height: 100%;
      display: flex;
      flex-flow: row;
      .left-content {
        display: flex;
        flex-flow: row;
        flex: 1;
        font-size: 20px;
        .left-content-box {
          color: #fff;
          font-size: 18px;
          margin: 10px;
          width: 100px;
          width: 154px;
          height: 60px;
          background: rgba(129, 129, 129, 1);
          border-radius: 4px;
          text-align: center;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
        }
        .spanColor {
          background: rgba(0, 151, 238);
          color: #fff;
        }
      }
    }
  }
  .box {
    width: 100%;
    height: 90%;
    background: rgba(2, 14, 27);
    .box-left {
      height: 100%;
      .left {
        width: 80%;
        height: 100%;
        display: flex;
        flex-flow: column;
        padding-top: 20px;
        box-sizing: border-box;
        margin: 0 auto;
        .left-top {
          font-size: 19px;
          line-height: 40px;
          background: rgba(71, 99, 121);
          font-weight: 600;
          margin-left: 14px;
          margin-right: 14px;
          margin-bottom: 8px;
          color: #fff;
        }
        .left-content {
          .left-content-box {
            color: #27f1f2;
            font-size: 18px;
            text-align: left;
            padding-left: 10px;
            line-height: 40px;
            cursor: pointer;
            margin: 0px;
          }
          .spanColor {
            background: rgba(132, 156, 44);
            color: #fff;
          }
        }
      }
    }
    .box-right {
      height: 100%;
      .main {
        height: 100%;
        margin-top: 5px;
        display: flex;
        flex-flow: column;
        .right-content {
          margin-top: 30px;
          display: flex;
          flex: 1;
          flex-flow: column;
          .right-content-top {
            justify-content: center;
            margin-bottom: 14px;
            display: flex;
            flex-flow: column;
            align-items: center;
            color: #fff;
            .right-content-top-title {
              font-size: 29px;
              color: #fff;
              line-height: 50px;
            }
            .right-content-top-usp {
              line-height: 46px;
              .usp-small {
                font-size: 16px;
                margin-left: 6px;
              }
            }
          }
          .imgBox {
            margin: 0 auto;
            margin-bottom: 20px;
            height: 688px;
            .imgTop {
              display: flex;
              // flex:1
              flex-flow: row;
              flex-direction: row;
              justify-content: space-between;
            }
            .imgbottom {
              display: flex;
              width: 1380px;
              height: 688px;
              .postTop {
                position: relative;
                height: 668px;
                .postimgone {
                  color: #fff;
                  position: absolute;
                  left: 140px;
                  .line {
                    position: absolute;
                    top: 50px;
                    left: 30px;
                    font-size: 28px;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: rgba(255, 255, 255, 1);
                  }
                }
                .postimgonennew {
                  color: #fff;
                  position: absolute;
                  left: 192px;
                  .line {
                    position: absolute;
                    top: 50px;
                    left: 30px;
                    font-size: 28px;
                    font-family: Source Han Sans CN;
                    font-weight: bold;
                    color: rgba(255, 255, 255, 1);
                  }
                }
                .postcentent {
                  position: absolute;
                  top: 134px;
                  bottom: 0px;
                  left: 0;
                  right: 0;
                  cursor: pointer;
                  .postimgtwo {
                    position: absolute;
                    left: 0;
                  }
                  .postbottom {
                    position: absolute;
                    top: 310px;
                  }
                  .samllpadding {
                    padding-left: 36px;
                    box-sizing: border-box;
                  }
                  .bigpadding {
                    padding-left: 14px;
                    box-sizing: border-box;
                  }
                  .imgtitle {
                    color: #fff;
                    text-align: left;
                    height: 250px;
                    display: flex;
                    flex-flow: column;
                    flex: 1;
                    .conten-box {
                      display: flex;
                      flex: 1;
                      .ziti {
                        width: 80px;
                        color: #ffff;
                      }
                      .value {
                        width: 72px;
                        color: rgba(151, 45, 22);
                      }
                      .valuewhile {
                        color: #ffffff;
                        width: 72px;
                      }
                      .valueGreen {
                        color: rgba(2, 239, 5);
                        width: 72px;
                      }
                      .valueYell {
                        width: 72px;
                        color: rgba(181, 134, 45);
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
</style>